**Deprecated:** Use `Attachment.seekRoleCode` instead.
